var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleXmarkSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
    fill: "#7E45C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.299 15.3591C14.5919 15.652 15.0668 15.652 15.3597 15.3591C15.6526 15.0662 15.6526 14.5913 15.3597 14.2984L13.062 12.0007L15.3591 9.70356C15.652 9.41066 15.652 8.93579 15.3591 8.6429C15.0662 8.35 14.5913 8.35 14.2984 8.6429L12.0013 10.94L9.70283 8.64155C9.40994 8.34865 8.93506 8.34865 8.64217 8.64155C8.34928 8.93444 8.34928 9.40931 8.64217 9.70221L10.9406 12.0007L8.64154 14.2998C8.34865 14.5926 8.34865 15.0675 8.64154 15.3604C8.93444 15.6533 9.40931 15.6533 9.70221 15.3604L12.0013 13.0613L14.299 15.3591Z",
    fill: "#252425"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleXmarkSolid);
export default __webpack_public_path__ + "static/media/circle-xmark-solid.46439f55.svg";
export { ForwardRef as ReactComponent };